import util from '@bmp-vue/core/api/util'
import Axios from 'axios'

const controller = 'Dbs'
const getToken = () => JSON.parse(localStorage.getItem('user'))?.token;
const url = process.env.VUE_APP_ROOT_API + controller

export default Object.assign({}, util.GetCrud(controller, ['none']), {
  PostFile: function (dto, disableLoading) {
    const request = { ...dto, ambiente: 274 }
    const headers = { Authorization: `Bearer ${getToken()}` }
    disableLoading ?? util.store.commit('addRequest')
    return Axios.post(`${url}/UploadArquivo`, request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  Post: function (acao, dto, disableLoading) {
    var request = { Dto: dto, Acao: acao, AmbienteDBS: 274 } // Quando 531 for utilizado, receber o valor por parâmetro
    const headers = { Authorization: `Bearer ${getToken()}` }
    disableLoading ?? util.store.commit('addRequest')
    return Axios.post(`${url}/Post`, request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },

  Put: function (acao, id, dto, disableLoading, queryParameters) {
    var request = { Dto: dto, Acao: acao, AmbienteDBS: 274 } // Quando 531 for utilizado, receber o valor por parâmetro
    const headers = { Authorization: `Bearer ${getToken()}` }
    const paramsUrl = new URLSearchParams({
      ...(queryParameters && { queryParameters: JSON.stringify(queryParameters) })
    })
    disableLoading ?? util.store.commit('addRequest')
    return Axios.put(`${url}/Put/${id}${queryParameters ? '?' + paramsUrl : ''}`, request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },

  Get: function (path, queryParameters, disableLoading) {
    const paramsUrl = new URLSearchParams({
      path: path,
      ambiente: 274, // Quando 531 for utilizado, receber o valor por parâmetro
      ...(queryParameters && { queryParameters: JSON.stringify(queryParameters) })
    })
    const headers = { Authorization: `Bearer ${getToken()}` }
    disableLoading ?? util.store.commit('addRequest')
    return Axios.get(`${url}/Get?${paramsUrl}`, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },

  Delete: function (path, queryParameters, disableLoading) {
    const paramsUrl = new URLSearchParams({
      path: path,
      ambiente: 274, // Quando 531 for utilizado, receber o valor por parâmetro
      ...(queryParameters && { queryParameters: JSON.stringify(queryParameters) })
    })
    const headers = { Authorization: `Bearer ${getToken()}` }
    disableLoading ?? util.store.commit('addRequest')
    return Axios.delete(`${url}/Delete/?${paramsUrl}`, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },

  EnviarTokenNumerico: function (acao, dtoToken, isReenvio, dto) {
    var request = { DtoToken: { Ambiente: process.env.VUE_APP_AMBIENTE, ...dtoToken }, Acao: acao, AmbienteDBS: 274, ...(isReenvio && { isReenvio }), dto } // Quando 531 for utilizado, receber o valor por parâmetro
    const headers = { Authorization: `Bearer ${getToken()}` }
    return util.Axios.Post(`${controller}/EnviarTokenNumerico`, request, headers)
  },

  ValidarTokenNumerico: function (acao, dtoToken, dto) {
    var request = { DtoToken: { Ambiente: process.env.VUE_APP_AMBIENTE, ...dtoToken }, Acao: acao, AmbienteDBS: 274, dto } // Quando 531 for utilizado, receber o valor por parâmetro
    const headers = { Authorization: `Bearer ${getToken()}` }
    return util.Axios.Post(`${controller}/ValidarTokenNumerico`, request, headers)
  },
  AssinarAceiteTermo: function (dto) {
    var request = { ...dto }
    return util.Axios.Post(`${controller}/AssinarAceiteTermo`, request)
  }
})
